/** The metadata types the explorer's `?node=Type:Name` deep link understands (anything else would open the wrong entity). */
export const METADATA_TYPE_TO_ENTITY_TYPE: Record<string, "class" | "trigger" | "object" | "flow"> = {
  ApexClass: "class",
  ApexTrigger: "trigger",
  CustomObject: "object",
  Flow: "flow",
};
